import { c as _c } from "react/compiler-runtime";
import { ReactNode } from 'react';
import { FormSelectWithGroups } from 'shared/components/form-select/form-select-with-groups';
import { useCalendars } from './hooks/use-calendars';
import { CalendarAccessRoleEnum, CalendarInterface } from './types';
const allowedAccessRoles: CalendarAccessRoleEnum[] = [CalendarAccessRoleEnum.Owner, CalendarAccessRoleEnum.Writer];
const SEPARATOR = `__${crypto.randomUUID()}__`;
const setUniqueCalendarValue = (calendarId: string, integrationId: string) => `${calendarId}${SEPARATOR}${integrationId}`;
const getCalendarDataFromUniqueValue = (value: string) => {
  const [calendarId, integrationId] = value.split(SEPARATOR);
  return {
    calendarId,
    integrationId
  };
};
export const GoogleCalendarSelector = t0 => {
  const $ = _c(21);
  const {
    calendar,
    disabled,
    label,
    className,
    onChange
  } = t0;
  const {
    data: calendars
  } = useCalendars();
  let t1;
  if ($[0] !== calendars) {
    t1 = calendars?.map(_temp);
    $[0] = calendars;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const groups = t1;
  let t2;
  if ($[2] !== calendars) {
    t2 = calendars?.filter(_temp2)?.map(_temp3);
    $[2] = calendars;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const calendarsOptions = t2;
  let t3;
  if ($[4] !== groups) {
    t3 = groups ?? [];
    $[4] = groups;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== calendarsOptions) {
    t4 = calendarsOptions ?? [];
    $[6] = calendarsOptions;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = !calendars;
  let t6;
  if ($[8] !== calendar) {
    t6 = calendar ? setUniqueCalendarValue(calendar.id, calendar.integration.id) : undefined;
    $[8] = calendar;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== onChange) {
    t7 = value => {
      if (!value) {
        return;
      }
      const {
        calendarId,
        integrationId
      } = getCalendarDataFromUniqueValue(value);
      onChange(calendarId, integrationId);
    };
    $[10] = onChange;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== className || $[13] !== disabled || $[14] !== label || $[15] !== t3 || $[16] !== t4 || $[17] !== t5 || $[18] !== t6 || $[19] !== t7) {
    t8 = <FormSelectWithGroups label={label} groups={t3} data={t4} disabled={disabled} isPreFetching={t5} value={t6} onChange={t7} withoutCloseIcon={true} containerClassName={className} />;
    $[12] = className;
    $[13] = disabled;
    $[14] = label;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
};
function _temp(calendar_0) {
  return {
    id: calendar_0.integration.id,
    caption: calendar_0.integration.googleUserEmail
  };
}
function _temp2(calendar_1) {
  return allowedAccessRoles.includes(calendar_1.accessRole);
}
function _temp3(calendar_2) {
  return {
    id: setUniqueCalendarValue(calendar_2.id, calendar_2.integration.id),
    group: calendar_2.integration.id,
    caption: calendar_2.name,
    customCaption: <div className="flex items-center gap-2"><span className="h-2 w-2 rounded-full" style={{
        backgroundColor: calendar_2.backgroundColor
      }} />{" "}{calendar_2.name}</div>
  };
}